import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";

import LangSwitcher from "../../Components/LangSwitcher";
import MainHeader from "../../Components/MainHeader/MainHeader";
import CustomButton from "../../Components/CustomButton";
import GoogleLoginBtn from "../../Components/GoogleLoginBtn";
import FacebookLoginBtn from "../../Components/FacebookLoginBtn";

import "./style.scss";

const RegiterMethodSelector = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const location = useLocation();
  const pricePlan = new URLSearchParams(location.search).get("pricePlan");

  return (
    <div className="main-container">
      <MainHeader />

      <div className="regiter-header">
        <h2>{t("register_method_selector_page_header")}</h2>
      </div>

      <div className="sso-section">
        <FacebookLoginBtn />
        <GoogleLoginBtn />
      </div>

      <div className="login-sections-devider">
        <div id="login-sections-devider-left"></div>
        <span>or</span>
        <div id="login-sections-devider-right"></div>
      </div>

      <div className="signup-button">
        <CustomButton
          fullWidth
          fontSize="1.2rem"
          onClick={() => {
            navigate(
              `/role-selector${pricePlan ? `?pricePlan=${pricePlan}` : ""}`,
            );
          }}
        >
          {t("sign_up")}
        </CustomButton>
      </div>

      <div className="regiter-page-langswitcher">
        <LangSwitcher />
      </div>
    </div>
  );
};

export default RegiterMethodSelector;
